import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { messageService } from "../../../services/message-services/message.service";

const initialState = {
    data: [],
    page: 1,
    limit: 15,
    total: 0,
    totalPages: 1,
    hasNext: false,
    hasPrev: false,
    status: null,
    error: null,
    trigger: 0,
};

const getQuizResponses = createAsyncThunk(
    "quizResponseSlice/getAll",
    async (params, { rejectWithValue }) => {
        try {
            return await messageService.getQuizResponse(params);
        } catch (e) {
            return rejectWithValue(e.response?.data?.message || "Something went wrong");
        }
    }
);

const updateQuizResponse = createAsyncThunk(
    "quizResponseSlice/update",
    async ({ id, data }, { rejectWithValue }) => {
        try {
            return await messageService.updateQuizResponse(id, data);
        } catch (e) {
            return rejectWithValue(e.response?.data?.message || "Something went wrong");
        }
    }
);

const quizResponseSlice = createSlice({
    name: "quizResponseSlice",
    initialState,
    reducers: {
        changeTrigger: (state) => {
            state.trigger += 1;
        },
        setPage: (state, action) => {
            state.page = action.payload;
        },
    },
    extraReducers: (builder) =>
        builder
            .addCase(getQuizResponses.pending, (state) => {
                state.status = "loading";
                state.error = null;
            })
            .addCase(getQuizResponses.fulfilled, (state, action) => {
                state.status = "fulfilled";
                state.data = action.payload.data;
                state.page = action.payload.page;
                state.limit = action.payload.limit;
                state.total = action.payload.total;
                state.totalPages = action.payload.totalPages;
                state.hasNext = action.payload.hasNext;
                state.hasPrev = action.payload.hasPrev;
            })
            .addCase(getQuizResponses.rejected, (state, action) => {
                state.status = "rejected";
                state.error = action.payload;
            })
            .addCase(updateQuizResponse.fulfilled, (state, action) => {
                const updated = action.payload;
                const index = state.data.findIndex((item) => item.id === updated.id);
                if (index !== -1) {
                    state.data[index] = updated;
                }
            }),
});

const { reducer: quizResponseReducer, actions } = quizResponseSlice;
const quizResponseActions = {
    ...actions,
    getQuizResponses,
    updateQuizResponse,
};

export { quizResponseReducer, quizResponseActions };
